import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';

import Contact from './components/Contact';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import MyPurchases from './components/MyPurchases';

import Courses from './components/Courses';
import CourseDetail from './components/CourseDetail';
import SearchPage from './components/SearchPage';
import ScrollToTopButton from './components/ScrollToTopButton';
import ChatbotWidget from './components/ChatbotWidget';
import useScrollToTop from './hooks/useScrollToTop';
import useActiveUsers from './hooks/useActiveUsers';
import './styles/range-slider.css';

function AppContent() {
  // Auto-scroll to top on route changes
  useScrollToTop();
  const activeUsers = useActiveUsers();

  return (
    <div className="min-h-screen bg-transparent flex flex-col">
          <Analytics />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#ffffff',
                color: '#000000',
                border: '2px solid #000000',
                borderRadius: '0px',
                boxShadow: '4px 4px 0px 0px #9FE240',
                fontWeight: 'bold',
                textTransform: 'uppercase'
              },
              success: {
                duration: 2000,
              }
            }}
          />
          <Navbar />
      <main className="w-full flex-grow">
            <Routes>
              <Route path="/" element={<Home activeUsers={activeUsers} />} />
              <Route path="/about" element={<About />} />

              <Route path="/contact" element={<Contact />} />
          <Route path="/digital-bundles" element={<Courses />} />
          <Route path="/digital-bundle/:id" element={<CourseDetail />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/my-purchases" element={<MyPurchases />} />
  
          <Route path="/search" element={<SearchPage />} />
            </Routes>
          </main>
      <Footer />
      <ScrollToTopButton />
      <ChatbotWidget />
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <AppContent />
      </Router>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
